import React, { useState, useEffect, useRef } from "react";
import { ExclamationCircleFilled, CheckCircleFilled } from "@ant-design/icons";
import { Tag, Spin } from "antd";
import { dateStringToStandardFormat } from "@/utils/dateFormatter";
import { STATUS } from "@/utils/enum";
import { getLotExitSummary } from "@/services/loads";

export default function LotExitTag({ loadId, bold }) {
  const lastLoadIdRef = useRef(null);

  const [status, setStatus] = useState(STATUS.IDLE);
  const [isLotExitPending, setIsLotExitPending] = useState(true);
  const [lotExitConfirmedAt, setLotExitConfirmedAt] = useState(null);

  useEffect(() => {
    if (!loadId) return;

    const fetchLotExitSummary = async () => {
      try {
        if (lastLoadIdRef.current === loadId) return;
        lastLoadIdRef.current = loadId;

        setStatus(STATUS.LOADING);
        const response = await getLotExitSummary(loadId);
        setStatus(STATUS.SUCCESS);
        const isLotExitCompleted = response?.pendingCount === 0 && !!response?.lastCompletedAt;
        setIsLotExitPending(!isLotExitCompleted);
        setLotExitConfirmedAt(response?.lastCompletedAt);
      } catch (error) {
        console.error("Error fetching lot exit summary:", error);
        setStatus(STATUS.ERROR);
      }
    };

    fetchLotExitSummary();
  }, [loadId]);

  if ([STATUS.ERROR, STATUS.IDLE].includes(status)) return null;

  if (status === STATUS.LOADING) return <Spin />;

  if (isLotExitPending) {
    return (
      <Tag color="warning" icon={<ExclamationCircleFilled />} style={{ fontWeight: bold ? "bold" : "normal" }}>
        LOT EXIT: Pending
      </Tag>
    );
  }

  return (
    <Tag color="success" icon={<CheckCircleFilled />} style={{ fontWeight: bold ? "bold" : "normal" }}>
      {lotExitConfirmedAt ? `LOT EXIT: ${dateStringToStandardFormat(lotExitConfirmedAt)}` : "LOT EXIT: Confirmed"}
    </Tag>
  );
}

LotExitTag.defaultProps = {
  bold: false,
};
